import React from 'react';
import { CustomModal, DataList } from 'commons-ui';
import { LIST_ENTITY_NAMES } from 'constant';
import useService from '../../../useService';
import { AthenaCrudRequestListConfig, DEFAULT_CONFIG } from './listConfig';

const AthenaCrudRequestVersionHistoryList: React.FC<{}> = () => {
	const { getAthenaRequestsVersionHistory } = useService();
	return (
		<div>
			<CustomModal />
			<DataList
				fetchData={getAthenaRequestsVersionHistory}
				columnConfigs={AthenaCrudRequestListConfig()}
				defaults={DEFAULT_CONFIG}
				disablePagination={false}
				disablePaginationSelect={false}
				entity={LIST_ENTITY_NAMES.ATHENA_CRUDS}
				initialSortDirection='ASC'
				initialSortIndex={0}
				filterable={false}
			/>
		</div>
	);
};

export default AthenaCrudRequestVersionHistoryList;
